import { render } from "./CurrentUser.vue?vue&type=template&id=0ca5c96e&scoped=true"
import script from "./CurrentUser.vue?vue&type=script&lang=js"
export * from "./CurrentUser.vue?vue&type=script&lang=js"

import "./CurrentUser.vue?vue&type=style&index=0&id=0ca5c96e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca5c96e"]])

export default __exports__